module.exports = __webpack_public_path__ + "static/media/caring-homecare.7829ff25.jpg";